<template>
    <v-navigation-drawer :value="siderLeftVisibility" app expand-on-hover>
        <Avatar></Avatar>
        <v-divider></v-divider>
        <Menu></Menu>
        <template v-slot:append>
            <Logout></Logout>
        </template>
    </v-navigation-drawer>
</template>

<script>
    import Menu from "../../modules/menu/index"
    import Logout from "../../components/Logout/index"
    import Avatar from "../../components/Avatar/index"
    import { mapState } from "vuex";

    export default {
        name: "SiderLeft",

        components: {
            Menu,
            Logout,
            Avatar
        },

        computed: {
            ...mapState([
                "siderLeftVisibility"
            ])
        },

        data: () => ({}),
    }
</script>
